import React from 'react';
import { Button } from './ui/button';

const LanguageToggle = ({ currentLang, onLanguageChange }) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant={currentLang === 'en' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onLanguageChange('en')}
        className={`px-3 py-1 text-sm font-medium transition-all duration-300 ${
          currentLang === 'en' 
            ? 'bg-[#00FFD1] text-black hover:bg-[#6FD2C0]' 
            : 'bg-transparent border border-white/25 text-white hover:bg-white hover:text-black'
        }`}
      >
        EN
      </Button>
      <Button
        variant={currentLang === 'id' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onLanguageChange('id')}
        className={`px-3 py-1 text-sm font-medium transition-all duration-300 ${
          currentLang === 'id' 
            ? 'bg-[#00FFD1] text-black hover:bg-[#6FD2C0]' 
            : 'bg-transparent border border-white/25 text-white hover:bg-white hover:text-black'
        }`}
      >
        ID
      </Button>
    </div>
  );
};

export default LanguageToggle;